import { Navigate, Outlet, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PageLayout } from '@/components/ui/PageLayout';
import { Tabs } from '@/components/ui/Tabs';

const TABS = [
  { to: '/medcom/letters', label: 'tabs.letters', about: 'about.letters' },
  { to: '/medcom/test', label: 'tabs.test', about: 'about.test' },
  { to: '/medcom/attachment', label: 'tabs.attachment', about: 'about.attachment' },
  { to: '/medcom/standarder', label: 'tabs.standarder', about: 'about.standarder' },
  { to: '/medcom/analysekatalog', label: 'tabs.catalogue', about: 'about.catalogue' },
] as const;

export function MedcomIndex() {
  const [params] = useSearchParams();
  if (params.get('action')) {
    return <Navigate to={`/medcom/test?${params.toString()}`} replace />;
  }
  return <Navigate to="/medcom/letters" replace />;
}

export function LegacyCareCommunicationsRedirect() {
  const location = useLocation();
  const rest = location.pathname.replace(/^\/care-communications/, '');
  return <Navigate to={`/medcom/letters${rest}${location.search}`} replace />;
}

export function MedcomSection() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const active = TABS.find((tab) => pathname === tab.to || pathname.startsWith(`${tab.to}/`)) ?? TABS[0];
  const isTabRoot = TABS.some((tab) => pathname === tab.to);

  return (
    <PageLayout
      title={isTabRoot ? undefined : t('medcomSection.title')}
      subtitle={isTabRoot ? undefined : t(`medcomSection.${active.about}`)}
    >
      <Tabs
        items={TABS.map((tab) => ({
          id: tab.to,
          label: t(`medcomSection.${tab.label}`),
        }))}
        value={active.to}
        onChange={(id) => navigate(id)}
        overflowLabel={(count) => t('design.more_tabs', { count })}
        ariaLabel={t('medcomSection.tabs_label')}
      />
      <div className="mt-s5 min-w-0">
        <Outlet />
      </div>
    </PageLayout>
  );
}
